const getters = {
    getUid: state => state.user.userInfo.uid,
    getToken: state => state.user.token
    // ...
};
export default getters;
